module.exports = __webpack_public_path__ + "img/qgiv.c63b0e1f.png";